/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useContext, useImperativeHandle } from "react";
import { MeetingContext } from "@/pages/Meeting";
import style from "./style.module.scss";
// import { init } from "@/MeetingSDK/drafty";

interface VideoViewProps {
  peerId: string;
  videoTrack?: MediaStreamTrack;
  audioTrack?: MediaStreamTrack;
  // video?: boolean;
  // audio?: boolean;
  // local?: boolean;
  // share?: boolean;
}
const VideoView = React.forwardRef((props: VideoViewProps, ref: any) => {

  const { peerId, videoTrack, audioTrack } = props;
  //const { service } = useContext(MeetingContext);

  const videoRef = useRef<HTMLVideoElement>();

  useEffect(() => {
    const stream = new MediaStream();
    if(videoTrack){
      console.log(`[VideoView] useEffect peerId=${peerId} videoTrack=${videoTrack}`)
      stream.addTrack(videoTrack);
      videoRef.current.srcObject = stream;
      videoRef.current.play();
    }      
  }, [videoTrack]);

    // Toggle Fullscreen for the video element
    const toggleFullScreen = () => {
      if (videoRef.current) {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch((err) => console.log(err));
        } else {
          videoRef.current.requestFullscreen().catch((err) => console.log(err));
        }
      }
    };

  return (
    <>
      <video
        className={style.video}
        ref={videoRef}
        style={{ opacity: videoTrack ? 1 : 0 }}
        controls={false}
        autoPlay
        muted
        onDoubleClick={toggleFullScreen}
      />
    </>
  );
});

export default VideoView;
